export default "__VITE_ASSET__$GNOe4YT__"